import App from './App.vue';
import { createApp } from 'vue';
import router from './router';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { createPinia } from 'pinia'

import mdiVue from 'mdi-vue/v3'
import * as mdijs from '@mdi/js'
import '@mdi/font/css/materialdesignicons.css'



const pinia = createPinia()

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        iconfont: 'mdi',
    },

})



const app = createApp(App).use(mdiVue, {
    icons: mdijs
})
app.use(pinia)
app.use(vuetify)
app.use(router)
app.mount('#app')